import React, { useEffect, useState, useRef } from "react";
import "./PopeyeDeals.scss";
import { getStateSmallIcon } from "../../../utils/images";
import PopeyeDealsCard from "./PopeyeDealsCard/PopeyeDealsCard";

// Define a function to repeat the deals list if necessary
const repeatDeals = (deals, times = 6) => {
  return Array.from({ length: times }, () => [...deals]).flat();
};

const PopeyeDeals = ({ deals = [] }) => {
  // Handle empty deals array
  const hasDeals = deals.length > 0;
  const dealsContainerRef = useRef(null); // Reference for the container
  const [animationDuration, setAnimationDuration] = useState(0); // State for dynamic duration

  const repeatedDeals = (() => {
    if (!hasDeals) return [];
    if (deals.length < 3) return [...deals];
    return repeatDeals(deals); // Duplicate the list for seamless scrolling
  })();

  useEffect(() => {
    // Calculate the animation duration based on the width of the content
    if (dealsContainerRef.current && deals.length > 0) {
      const containerWidth = dealsContainerRef.current.scrollWidth; // Total width of items
      const speed = 100; // Speed in pixels per second (adjust as needed)
      const duration = containerWidth / speed; // Calculate duration
      setAnimationDuration(duration);
    }
  }, [deals]);

  return (
    <div className="PopeyeDeals">
      <div className="subheader">
        <img
          className="logo"
          src={getStateSmallIcon("deal")}
          alt="deal Logo"
        />
        <p>Deals</p>
      </div>
      <div
        className={`deals-container ${deals.length > 3 ? "scrolling" : ""}`}
        style={{
          animationDuration: `${animationDuration}s`, // Dynamically set animation duration
        }}
        ref={dealsContainerRef}
      >
        {hasDeals ? (
          // Render deals items, possibly with some duplication for seamless scrolling
          repeatedDeals.map((deal, index) => (
            <div key={index} className="deals-item">
              <PopeyeDealsCard deal={deal} />
            </div>
          ))
        ) : (
          // Render a placeholder or message when no deals are available
          <div className="no-deals-message">
            <p>
              No deals are available at the moment.{" "}
              <a
                href="https://nowlun.com/search_price"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here
              </a>{" "}
              to begin your journey.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopeyeDeals;
